import type { DashboardOverview, LiveStats } from "@/types/api";

/**
 * Local demo data used whenever the API hasn't returned data yet (no
 * backend wired up in this environment). Mirrors the DashboardOverview /
 * LiveStats shapes exactly so swapping in real data is a no-op.
 */
export const mockOverview: DashboardOverview = {
  totalLeads: 1847,
  activeLeads: 234,
  conversionRate: 28.5,
  responseTime: 2.3,
  connectedAccounts: { meta: 3, ecommerce: 1, total: 4 },
  recentActivity: [
    {
      id: "1",
      type: "lead",
      message:
        "New lead from Facebook: Sarah Johnson interested in premium package",
      timestamp: new Date(Date.now() - 2 * 60 * 1000).toISOString(),
    },
    {
      id: "2",
      type: "message",
      message:
        "Message sent to John Smith via WhatsApp - Order confirmation",
      timestamp: new Date(Date.now() - 5 * 60 * 1000).toISOString(),
    },
    {
      id: "3",
      type: "integration",
      message: "Instagram account connected successfully",
      timestamp: new Date(Date.now() - 15 * 60 * 1000).toISOString(),
    },
    {
      id: "4",
      type: "conversion",
      message: "Lead converted: Maria Garcia purchased $450 package",
      timestamp: new Date(Date.now() - 32 * 60 * 1000).toISOString(),
    },
  ],
  leadsOverTime: [
    { date: "2024-01-01", count: 45, converted: 12 },
    { date: "2024-01-02", count: 52, converted: 15 },
    { date: "2024-01-03", count: 38, converted: 9 },
    { date: "2024-01-04", count: 67, converted: 18 },
    { date: "2024-01-05", count: 43, converted: 14 },
    { date: "2024-01-06", count: 59, converted: 21 },
    { date: "2024-01-07", count: 71, converted: 25 },
  ],
  platformDistribution: [
    { platform: "Facebook", count: 124, percentage: 45 },
    { platform: "Instagram", count: 89, percentage: 32 },
    { platform: "WhatsApp", count: 43, percentage: 16 },
    { platform: "Website", count: 21, percentage: 7 },
  ],
};

export const mockLiveStats: LiveStats = {
  activeConnections: 12,
  messagesLastHour: 34,
  pendingLeads: 8,
  systemHealth: "healthy",
};

// Note: quick actions already have their own mock source in
// ../hooks/useDashboard.ts (useQuickActions) — not duplicated here.
